
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';

const Addtask = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        projname: '',
        taskname:'',
        count:false,
        remarks:false,
        ongoing:false
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        _getproject();
        gettask();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));

        if(name == 'count' || name == 'remarks' || name == 'ongoing'){
            const { name, checked } = e.target;
            setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
            }));
        }
     };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('form daat');
        console.log(formData);
        addtask({task:formData});
        // addproject({project:formData.projectname});
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        // projname: '',
        // taskname:'',
        // count:false,
        // remarks:false,
        // ongoing:false
  
        if (formData.projname == '') {
          newErrors.projname = 'Project name is required';
          valid = false;
        }

        if (formData.taskname == '') {
            newErrors.taskname = 'Task name is required';
            valid = false;
          }

        setErrors(newErrors);

       return valid; 
    }

    function addtask({task}){

        if(!validateForm()){
            return;
         }
        adminService.addtask({tasks:task}).then((response)=>{
        //    console.log('response'); 
        //    console.log(response);
           if(response.status == 200){
            toast.current.show({severity:'success', summary: "Task", detail:`Task updated successfully!`, life: 3000}); 
           }else{
            toast.current.show({severity:'error', summary: "Task", detail:`Not updated!`, life: 3000});
           } 
           gettask();
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Task", detail:`Not updated!`, life: 3000});
        });
    } 

    function gettask(){
        let emparr = [];
        setloading(false);
        adminService.gettasks().then((response)=>{
            console.log('response'); 
            console.log(response.data.data); 
            response.data.data.forEach((value,index)=>{
                emparr.push((<tr key={index}>
                    <td scope="col">{value.id}</td>
                    <td scope="col">{value.projname}</td>
                    <td scope="col">{value.name}</td>
                    <td scope="col">{value.count}</td>
                    <td scope="col">{value.remarks}</td>
                    <td scope="col">Ongoing</td>
                </tr>));
            }); 
            setDatacomp(emparr); 
            setloading(true);
            setDatastate(true);
         }).catch((error)=>{
            setloading(true);
            setDatastate(true);
         });  
    }


    function _getproject(){
        let emparr = [];
        setloading(false);

        adminService.getproject().then((response)=>{
           console.log('response'); 
        //    console.log(response.data.data); 
           response.data.data.forEach((value,index)=>{
             console.log(value.name);
             emparr.push(<option value={value.name}>{value.name}</option>);
           });
           setProjcomp(emparr);
        //    setDatacomp([]);
           setloading(true);
           setDatastate(true);
        //    const [datacomp,setDatacomp] = useState([]); 
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });
    } 


   return (
        <>
            <div className="invisible-divider-sm"></div>
            <Toast ref={toast} />
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-3">
                        <label className='pull-left'>Select Project</label>
                        <br/>
                        <select className='custom-dropdown-style' name="projname" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Project</option>
                           {projcomp}
                        </select>
                        {errors.projname && <span className='error'>{errors.projname}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>New Task Name</label>
                        <br/>
                        <input type='text' name='taskname' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {errors.taskname && <span className='error'>{errors.taskname}</span>}
                    </div>
                    <div className="col-md-4">
                       <div className="row">
                          <div className='col-md-4'>
                            <label className='pull-left'>Count</label>
                             <br/>
                             <input type='checkbox' name='count' className='custom-checkbox-style pull-left' onChange={(e)=>handleChange(e)} />  
                          </div> 
                          <div className='col-md-4'>
                            <label className='pull-left'>Remarks</label>
                             <br/>
                             <input type='checkbox' name='remarks' className='custom-checkbox-style pull-left' onChange={(e)=>handleChange(e)} />  
                          </div> 
                          <div className='col-md-4'>
                            <label className='pull-left'>Ongoing</label>
                             <br/>
                             <input type='checkbox' name='ongoing' className='custom-checkbox-style pull-left' onChange={(e)=>handleChange(e)} />  
                          </div> 
                       </div>
                    </div>
                    <div className="col-md-2 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style' />
                        </div>

                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Project</th>
                                <th scope="col">Task Name</th>
                                <th scope="col">Count</th>
                                <th scope="col">Remarks</th>
                                <th scope="col">Ongoing</th>
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Addtask;
